import "core-js/modules/es6.reflect.construct.js";
import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import toFragment from 'rc-util/lib/Children/mapSelf';
import cx from 'classnames';
import TodayButton from '../calendar/TodayButton';
import OkButton from '../calendar/OkButton';
import TimePickerButton from '../calendar/TimePickerButton';

var CalendarFooter = /*#__PURE__*/function (_React$Component) {
  _inherits(CalendarFooter, _React$Component);

  var _super = _createSuper(CalendarFooter);

  function CalendarFooter() {
    _classCallCheck(this, CalendarFooter);

    return _super.apply(this, arguments);
  }

  _createClass(CalendarFooter, [{
    key: "onSelect",
    value: function onSelect(value) {
      this.props.onSelect(value);
    }
  }, {
    key: "getRootDOMNode",
    value: function getRootDOMNode() {
      return ReactDOM.findDOMNode(this);
    }
  }, {
    key: "render",
    value: function render() {
      var props = this.props;
      var value = props.value,
          prefixCls = props.prefixCls,
          showOk = props.showOk,
          timePicker = props.timePicker,
          renderFooter = props.renderFooter,
          mode = props.mode;
      var footerEl = null;
      var extraFooter = renderFooter && renderFooter(mode);

      if (props.showToday || timePicker || extraFooter) {
        var nowEl;

        if (props.showToday) {
          nowEl = /*#__PURE__*/React.createElement(TodayButton, _extends({}, props, {
            value: value
          }));
        }

        var okBtn;

        if (showOk === true || showOk !== false && !!props.timePicker) {
          okBtn = /*#__PURE__*/React.createElement(OkButton, props);
        }

        var timePickerBtn;

        if (!!props.timePicker) {
          timePickerBtn = /*#__PURE__*/React.createElement(TimePickerButton, props);
        }

        var footerBtn;

        if (nowEl || timePickerBtn || okBtn || extraFooter) {
          footerBtn = /*#__PURE__*/React.createElement("span", {
            className: "".concat(prefixCls, "-footer-btn")
          }, extraFooter ? /*#__PURE__*/React.createElement("div", {
            className: "".concat(prefixCls, "-footer-extra")
          }, extraFooter) : null, toFragment([nowEl, timePickerBtn, okBtn]));
        }

        var cls = cx("".concat(prefixCls, "-footer"), _defineProperty({}, "".concat(prefixCls, "-footer-show-ok"), okBtn));
        footerEl = /*#__PURE__*/React.createElement("div", {
          className: cls
        }, footerBtn);
      }

      return footerEl;
    }
  }]);

  return CalendarFooter;
}(React.Component);

_defineProperty(CalendarFooter, "propTypes", {
  prefixCls: PropTypes.string,
  showDateInput: PropTypes.bool,
  disabledTime: PropTypes.any,
  timePicker: PropTypes.element,
  selectedValue: PropTypes.any,
  showOk: PropTypes.bool,
  onSelect: PropTypes.func,
  value: PropTypes.object,
  renderFooter: PropTypes.func,
  defaultValue: PropTypes.object,
  mode: PropTypes.string
});

export { CalendarFooter as default };


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-datepicker/src/rc-calendar/calendar/CalendarFooter.js